import Whatsapp from "./Whatsapp"
export default Whatsapp
